const typography = [
  {
    name: 'Text Align',
    classMk: ['text-left', 'text-center', 'text-right', 'text-justify'],
  },
  {
    name: 'Text Decoration',
    classMk: ['text-none', 'text-under', 'text-through', 'text-over'],
  },
  {
    name: 'Text Transform',
    classMk: ['text-capitalize', 'text-upper', 'text-lower'],
  },
  {
    name: 'Font Family',
    classMk: [
      'font-mono',
      'font-sans',
      'font-serif',
      'font-oswald',
      'font-roboto',
      'font-inter',
    ],
  },
  {
    name: 'Font Size',
    scroll: 'scroll',
    classMk: [
      'font-xs',
      'font-sm',
      'font-md',
      'font-lg',
      'font-xl',
      'font-2xl',
      'font-3xl',
      'font-4xl',
      'font-5xl',
    ],
  },
  {
    name: 'Font Weight',
    classMk: [
      'font-light',
      'font-base',
      'font-medium',
      'font-bold',
      'font-extrabold',
    ],
  },
  {
    name: 'Font Style',
    classMk: ['font-italic', 'font-normal', 'font-oblique'],
  },
];
export default typography;
